module.exports = __webpack_public_path__ + "static/img/p-s4-5.f17d901e.png";